import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import LiveHelpOutlinedIcon from 'components/material-symbol/icons/LiveHelp'
import {
  INTERCOM_HELP_LAUNCHER_ID,
  useSupportContactActions,
} from 'lib/support'

const ContactButton = () => {
  const { openSupport } = useSupportContactActions()

  return (
    <IconButton
      id={INTERCOM_HELP_LAUNCHER_ID}
      color="primary"
      aria-label="Contact support"
      onClick={openSupport}
    >
      <LiveHelpOutlinedIcon />
    </IconButton>
  )
}

export default ContactButton
